import React, { useState } from "react";
import toast from "react-hot-toast";
import {
  getCurrentFYByDate,
  minutesToHHMM,
  secondsToHHMM,
  timeToSeconds,
} from "../../Utilitie";

const LongHaulHOInsertion = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const [globalDate, setGlobalDate] = useState(
    new Date().toISOString().slice(0, 10),
  );
  const fyData = getCurrentFYByDate(globalDate) || {};

  const [entries, setEntries] = useState([
    {
      EX: "",
      TRAIN_NO_I: "",
      TRAIN_NO_II: "",
      ENGINE_NO: "",
      ENGINE_NO_II: "",
      DEP: "",
      HAND_OVER: "",
      DETENTION: "",
      STATION: "",
      TP_SP: "",
      REMARKS: "",
    },
  ]);

  const keys = [
    "EX",
    "TRAIN_NO_I",
    "TRAIN_NO_II",
    "ENGINE_NO",
    "ENGINE_NO_II",
    "DEP",
    "HAND_OVER",
    "DETENTION",
    "STATION",
    "TP_SP",
    "REMARKS",
  ];
  const handleChange = (rowIndex, key, value) => {
    setEntries((prev) =>
      prev.map((row, i) => {
        if (i !== rowIndex) return row;

        const updated = { ...row };

        if (key === "DEP" || key === "HAND_OVER") {
          updated[key] = timeToSeconds(value);

          const dep = updated.DEP;
          const hnd = updated.HAND_OVER;

          if (dep && hnd) {
            const detention = Math.abs(hnd - dep);
            updated.DETENTION = detention;
          } else {
            updated.DETENTION = 0;
          }
        } else {
          updated[key] = value;
        }

        return updated;
      }),
    );
  };

  const addRow = () => {
    setEntries((prev) => [
      ...prev,
      {
        EX: "",
        TRAIN_NO_I: "",
        TRAIN_NO_II: "",
        ENGINE_NO: "",
        ENGINE_NO_II: "",
        DEP: "",
        HAND_OVER: "",
        DETENTION: "",
        STATION: "",
        TP_SP: "",
        REMARKS: "",
      },
    ]);
  };

  const removeRow = (index) =>
    setEntries((prev) => prev.filter((_, i) => i !== index));
  const handleClear = () => setEntries([]);

  const handleSubmit = async () => {
    const dataToSend = entries.map((entry) => ({
      ...entry,
      F_YEAR: fyData.FY || "",
      A_MONTH: fyData.month || "",
      A_DATE: globalDate,
    }));

    try {
      const response = await fetch(`${urlPrefix}insert/longhaulHandover`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataToSend),
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result?.message || "HTTP error");

      toast.success("✅ Data uploaded successfully!");
      setEntries([
        {
          EX: "",
          TRAIN_NO_I: "",
          TRAIN_NO_II: "",
          ENGINE_NO: "",
          ENGINE_NO_II: "",
          DEP: "",
          HAND_OVER: "",
          DETENTION: "",
          STATION: "",
          TP_SP: "",
          REMARKS: "",
        },
      ]);
    } catch (error) {
      toast.error("❌ Failed to upload data");
      console.error("Upload error:", error);
    }
  };

  const handleDateChange = (value) => {
    setGlobalDate(value);
  };

  return (
    <div className="papaDiv">
      <h5 className="p-2 bg-dark text-white text-center">
        Insert Data in Long Haul Hand Over
      </h5>

      <div className="d-flex justify-content-center align-items-center gap-3 m-3">
        <div>
          <label className="fw-bold me-2">Select Date:</label>
          <input
            type="date"
            className="form-control d-inline-block"
            style={{ width: "180px", fontSize: "0.9rem" }}
            value={globalDate}
            onChange={(e) => handleDateChange(e.target.value)}
          />
        </div>
        <div>
          <span className="badge bg-primary me-2">
            FY: {fyData.FY || "N/A"}
          </span>
          <span className="badge bg-success">
            Month: {fyData.month || "N/A"}
          </span>
        </div>
        <button className="btn btn-outline-dark m-2" onClick={addRow}>
          Add Row
        </button>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped mb-4 text-center align-middle">
          <thead className="table-dark">
            <tr>
              <th>Sr No. </th>
              {keys.map((key, i) => (
                <th key={i}>{key.replace(/_/g, " ")}</th>
              ))}
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {entries.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{rowIndex + 1}.</td>

                {keys.map((key, index) => (
                  <td key={index}>
                    {key === "ENGINE_NO" || key === "ENGINE_NO_II" ? (
                      <div className="d-flex gap-1">
                        {["first", "second"].map((_, i) => {
                          const parts = String(row[key] || "").split("+");
                          return (
                            <input
                              key={i}
                              type="number"
                              placeholder={`Part ${i + 1}`}
                              className="form-control"
                              style={{ width: "75px", fontSize: "0.8rem" }}
                              value={parts[i] || ""}
                              onChange={(e) => {
                                parts[i] = e.target.value.slice(0, 5);
                                handleChange(
                                  rowIndex,
                                  key,
                                  parts.filter(Boolean).join("+"),
                                );
                              }}
                            />
                          );
                        })}
                      </div>
                    ) : key === "DEP" || key === "HAND_OVER" ? (
                      <input
                        type="time"
                        className="form-control"
                        style={{ width: "140px", fontSize: "0.8rem" }}
                        value={row[key] ? secondsToHHMM(row[key]) : ""}
                        onChange={(e) =>
                          handleChange(rowIndex, key, e.target.value)
                        }
                      />
                    ) : key === "DETENTION" ? (
                      <input
                        disabled
                        type="number"
                        value={row[key] || ""}
                        onChange={(e) =>
                          handleChange(rowIndex, key, e.target.value)
                        }
                      />
                    ) : key === "TP_SP" ? (
                      <select
                        className="form-control"
                        style={{ width: "100px", fontSize: "0.8rem" }}
                        value={row[key]}
                        onChange={(e) =>
                          handleChange(rowIndex, key, e.target.value)
                        }
                      >
                        <option value="" hidden>
                          Select
                        </option>
                        <option value="TP">TP</option>
                        <option value="SP">SP</option>
                      </select>
                    ) : (
                      <input
                        type="text"
                        className="form-control"
                        style={{ width: "100px", fontSize: "0.8rem" }}
                        value={row[key]}
                        onChange={(e) =>
                          handleChange(rowIndex, key, e.target.value)
                        }
                      />
                    )}
                  </td>
                ))}

                <td>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => removeRow(rowIndex)}
                  >
                    🗑
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-center mt-3">
        <button className="btn btn-outline-danger m-2" onClick={handleClear}>
          Clear
        </button>
        <button className="btn btn-outline-success m-2" onClick={handleSubmit}>
          Upload
        </button>
      </div>
    </div>
  );
};

export default LongHaulHOInsertion;
